import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useMaintenanceStore = defineStore('Maintenance', () => {
  const title = ref('')
  const body = ref('')
  const maintenance = ref(false)

  /* eslint-disable camelcase */
  const booking_widget_is_active = ref(false)
  const search_bar_is_active = ref(false)
  const maintenance_response = ref({})
  /* eslint-enable camelcase */

  function updateErrorTitle(value) {
    title.value = value
  }

  function updateErrorBody(value) {
    body.value = value
  }

  function updateMode(value) {
    maintenance.value = value
  }

  function updateSearchBarOn(value) {
    search_bar_is_active.value = value
  }

  function updateBookingWidgetOn(value) {
    booking_widget_is_active.value = value
  }

  return {
    title,
    body,
    maintenance,
    booking_widget_is_active,
    search_bar_is_active,
    maintenance_response,

    updateErrorTitle,
    updateErrorBody,
    updateMode,
    updateSearchBarOn,
    updateBookingWidgetOn
  }
})
